import { z } from 'zod';

/**
 * Counts rendered as badges on the org workspace sidebar. Loaded in a
 * single request (`GET /orgs/:orgId/sidebar-counts`):
 *
 *   - `overview` — items in the requesting agent's overview buckets
 *     (open, squad'd cards assigned to them or awaiting the human queue).
 *   - `triage`   — open untriaged cards (no `squadId`).
 *   - `squads`   — per-squad card count (open + recently-resolved, i.e.
 *     within the org's resolved-retention window). The project badge is
 *     the sum of its squads, computed client-side.
 */
export const SidebarCountsSchema = z.object({
  overview: z.number().int().min(0),
  triage: z.number().int().min(0),
  squads: z.record(z.string(), z.number().int().min(0)),
});

export type SidebarCounts = z.infer<typeof SidebarCountsSchema>;
